import { create } from 'zustand';

import { createInboxEntryActivityLogsSlice } from './actions';
import { InboxEntryActivityLogsStore } from './types';

export const useInboxEntryActivityLogsStore =
  create<InboxEntryActivityLogsStore>()((set, get, store) => ({
    ...createInboxEntryActivityLogsSlice(set, get, store),
  }));
